export default {"src":"/_next/static/media/adventurewurld-token.ee308fe6.svg","height":144,"width":144};